import React, {useState} from "react";
import {Button, Col, Row, Tabs, message, Modal, Spin} from "antd";
import moment from "moment";
import DetailTable from "../../components/detailtable/DetailTable";
import './AssetEventOrders.less';


const AssetEventOrders = ({orders = [], loading}) => {
    if(loading)
        return (
            <Spin size="small"/>
        )

    if(orders.length === 0){
        return (
            <div>Нет данных</div>
        )
    }


    return (
        <>
            <div className='ip-asset-event-orders-table'>
                <DetailTable>
                    <thead>
                    <tr>
                        <th className="column-id text-center">ID</th>
                        <th className="column-status text-center">Статус</th>
                        <th className="column-created text-center">Создан</th>
                        <th className="column-created text-center">Завершен</th>
                        <th className="column-processing text-center">Стратегия</th>
                        <th className="column-error-time text-center">Тип</th>
                        <th className="column-error-message text-left">Направление</th>
                        <th className="column-error-message text-left">Кол-во запр.</th>
                        <th className="column-error-message text-left">Кол-во вып.</th>
                        <th className="column-account text-left">Брокер счет</th>
                        <th className="column-account text-left">Брокер ордер</th>
                        <th className="column-account text-left">Брокер API</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orders.map(({id, createdAt, completedAt, status, brokerOrderId, brokerAccountId,
                                 security = {}, strategy = {}, direction, orderType,
                                 initialPrice, executedPrice, requestedQuantity, executedQuantity, brokerApiType}) => {
                        const {name: strategyName} = strategy;
                        return (
                            <tr key={id}>
                                <td className="column-id text-center"><span className="id-cell">#{id}</span></td>
                                <td>{status}</td>
                                <td>{createdAt ? moment(createdAt).format('DD.MM.YYYY HH:mm:ss') : null}</td>
                                <td className="column-done text-center">
                                    <span className={`timestamp completed ${!completedAt ? 'empty' : ''}`}>
                                        {completedAt ? moment(completedAt).format('DD.MM.YYYY HH:mm') : '—'}
                                    </span>
                                </td>
                                <td>{strategyName}</td>
                                <td>{orderType}</td>
                                <td>{direction}</td>
                                <td>{requestedQuantity}</td>
                                <td>{executedQuantity}</td>
                                <td>{brokerAccountId}</td>
                                <td>{brokerOrderId}</td>
                                <td>{brokerApiType}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </DetailTable>
            </div>
        </>
    );
};

export default AssetEventOrders;
